'use client';
import { useState } from 'react';
import Link from 'next/link';
import { TestimonialItem } from '@/components/pages/TestimonialsPage/Testimonials/TestimonialItem/TestimonialItem';
import { CreateReviewModal } from '@/components/features/CreateReviewModal/CreateReviewModal';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import Modal from '@/components/layouts/Modal/Modal';
import { ITestimonialItem } from '@/api/testimonials/testimonials.types';
import s from './ReviewsMain.module.scss';

export const ReviewsMain = ({ reviews }: { reviews: ITestimonialItem[] }) => {
  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const closeModal = () => setIsOpenCreate(false);

  return (
    <>
      <section className={s.reviews}>
        <div className="custom-container">
          <div className={s.reviews__head}>
            <h2>Отзывы</h2>
            <Link className={s.reviews__link} href={'/testimonials'}>Все отзывы</Link>
          </div>
          <ul className={s.reviews__list}>
            {reviews.map((card) => (
              <li key={card.id}>
                <TestimonialItem testimonial={card} abbreviated forMainPage />
              </li>
            ))}
          </ul>
          <Link className={s.reviews__link_mobile} href={'/testimonials'}>Все отзывы</Link>
          <ActionButton onClick={() => setIsOpenCreate(true)}>Оставить отзыв</ActionButton>
        </div>
      </section>
      <Modal isOpen={isOpenCreate} onClose={closeModal} className={s.reviews__modal}>
        <CreateReviewModal onSuccess={closeModal} />
      </Modal>
    </>
  );
};